import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const GuestBanner = ({ user, onConvertAccount }) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(true);

    // Only show for guest users
    if (!user?.is_guest || !isVisible) {
        return null;
    }

    return (
        <Collapse in={isVisible}>
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    py: 1.5,
                    px: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                    position: 'relative',
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: 1,
                        fontWeight: 500,
                    }}
                >
                    <PersonAddIcon sx={{ fontSize: 20 }} />
                    {t('guest_account_notice')}
                </Typography>
                
                <Button
                    variant="contained"
                    size="small"
                    onClick={onConvertAccount}
                    sx={{
                        bgcolor: 'white',
                        color: '#667eea',
                        fontWeight: 600,
                        '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.9)',
                            transform: 'scale(1.02)',
                        },
                        transition: 'all 0.2s ease',
                        textTransform: 'none',
                        px: 2,
                    }}
                >
                    {t('convert_guest_account')}
                </Button>
                
                <IconButton
                    size="small"
                    onClick={() => setIsVisible(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        color: 'white',
                        opacity: 0.8,
                        '&:hover': {
                            opacity: 1,
                            bgcolor: 'rgba(255,255,255,0.1)',
                        },
                    }}
                    aria-label={t('dismiss')}
                >
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </Box>
        </Collapse>
    );
};

export default GuestBanner;
